import { Injectable, signal } from '@angular/core';

/**
 * Contains the Media Manager state.
 *
 * This is used with {@link MediaManagerService} to emit its state.
 */
@Injectable({
  providedIn: 'root',
})
export class MediaManagerRepository {
  /**
   * All Media (both streaming providers and native) have unique system IDs.
   *
   * Each time a media plays, its unique ID is set (or removed) globally so that
   * any media which is not the active media can be paused.
   */
  private readonly _activeMediaID = signal<string | null>(null);

  /**
   * The unique ID of the media that is currently playing globally, or null when none is.
   */
  readonly activeMediaID = this._activeMediaID.asReadonly();

  /**
   * Set (or remove) the globally active media ID.
   */
  applyActiveMediaID(id: string | null) {
    this._activeMediaID.set(id);
  }
}
